import { Text, useShowContextRequired } from 'ui-builder';
import { MarketRequest, MarketRequestStatus } from 'nekst-api';
import React from 'react';

export default function RequestStatusField() {
  const { data  } = useShowContextRequired<MarketRequest>();

  if (data.status === MarketRequestStatus.IN_PROGRESS) {
    return (<Text>In progress</Text>)
  } else {
    return (<Text>Processed</Text>);
  }
}
